import { GaEventAction } from '../../../common/GaEventAction';

export type HeaderOldMainMenuItemKind = 'route' | 'device-menu';

export interface HeaderOldMainMenuContext {
  featureFlags: string[];
  hasAdminRole: boolean;
  hasBillingRole: boolean;
  hasDevices: boolean;
  hasLicensesAccess: boolean;
  hasSuperAdminRole: boolean;
}

export interface HeaderOldMainMenuItem {
  kind: HeaderOldMainMenuItemKind;
  labelKey: string;
  path?: string;
  gaAction?: GaEventAction;
  disabled?: boolean;
  featureFlag?: string;
  hiddenWhenFeatureFlag?: string;
  requiresAdminOrSuperAdmin?: boolean;
  requiresBillingOrSuperAdmin?: boolean;
  requiresLicensesAccess?: boolean;
  requiresNotBilling?: boolean;
  requiresSuperAdmin?: boolean;
}

const OLD_MAIN_MENU_ITEMS: HeaderOldMainMenuItem[] = [
  {
    kind: 'device-menu',
    labelKey: 'link_selected_device',
    gaAction: GaEventAction.MENU_SELECTED_DEVICE_PAGE_CLICK,
  },
  {
    kind: 'route',
    labelKey: 'link_devices',
    path: '/app/Devices',
    gaAction: GaEventAction.MENU_DEVICES_PAGE_CLICK,
  },
  {
    kind: 'route',
    labelKey: 'link_alarms',
    path: '/app/AllAlarms',
    gaAction: GaEventAction.MENU_ALL_ALARMS_PAGE_CLICK,
  },
  {
    kind: 'route',
    labelKey: 'link_reports',
    path: '/app/ReportsExport',
    gaAction: GaEventAction.MENU_REPORTS_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_scheduled_reports',
    path: '/app/ScheduledReportsConfig',
    gaAction: GaEventAction.MENU_SCHEDULED_REPORTS_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_billing_report',
    path: '/app/BillingReport',
    gaAction: GaEventAction.MENU_BILLING_REPORT_PAGE_CLICK,
    featureFlag: 'BILLING_REPORT_PAGE',
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_export',
    path: '/app/DeviceCountersExport',
    gaAction: GaEventAction.MENU_EXPORT_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_map',
    path: '/app/DeviceLocation',
    gaAction: GaEventAction.MENU_MAP_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_graph',
    path: '/app/NewGraph',
    gaAction: GaEventAction.MENU_GRAPH_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_transmissions',
    path: '/app/Transmissions',
    gaAction: GaEventAction.MENU_TRANSMISSIONS_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_inventory',
    path: '/app/DeviceInventory',
    gaAction: GaEventAction.MENU_INVENTORY_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_link_device',
    path: '/app/LinkDevices',
    gaAction: GaEventAction.MENU_LINK_DEVICE_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_show_users',
    path: '/app/Users',
    gaAction: GaEventAction.MENU_USERS_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_accounts',
    path: '/app/Accounts',
    gaAction: GaEventAction.MENU_ACCOUNTS_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_device_account_lookup',
    path: '/app/DeviceCompanyLookup',
    requiresSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_accounts_manager',
    path: '/app/AccountsManager',
    gaAction: GaEventAction.MENU_MANAGE_ACCOUNTS_PAGE_CLICK,
    hiddenWhenFeatureFlag: 'CREATE_ACCOUNT_MODAL',
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_licenses',
    path: '/app/Licenses',
    gaAction: GaEventAction.MENU_MANAGE_LICENSES_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
    requiresLicensesAccess: true,
  },
  {
    kind: 'route',
    labelKey: 'link_battery',
    path: '/app/DevicesBattery',
    gaAction: GaEventAction.MENU_DEVICES_BATTERY_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'device_groups',
    path: '/app/DeviceGroups',
    gaAction: GaEventAction.MENU_DEVICE_GROUP_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_device_nodes',
    path: '/app/DeviceNodes',
    gaAction: GaEventAction.MENU_DEVICE_NODES_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_signal',
    path: '/app/DevicesSignal',
    gaAction: GaEventAction.MENU_DEVICES_SIGNAL_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_icons',
    path: '/app/icons',
    gaAction: GaEventAction.MENU_ICON_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_dashboard',
    path: '/app',
    gaAction: GaEventAction.MENU_DASHBOARD_PAGE_CLICK,
    requiresAdminOrSuperAdmin: true,
    requiresNotBilling: true,
  },
  {
    kind: 'route',
    labelKey: 'link_dashboard_2',
    path: '/app/dashboard',
    gaAction: GaEventAction.MENU_DASHBOARD_PAGE_CLICK,
    featureFlag: 'NEW_DASHBOARD_PAGE',
    requiresAdminOrSuperAdmin: true,
  },
  {
    kind: 'route',
    labelKey: 'link_customer_billing_report',
    path: '/app/CustomerBillingReport',
    gaAction: GaEventAction.MENU_CUSTOMER_BILLING_REPORT_PAGE_CLICK,
    requiresBillingOrSuperAdmin: true,
  },
];

function isOldMainMenuItemVisible(
  item: HeaderOldMainMenuItem,
  context: HeaderOldMainMenuContext
): boolean {
  if (item.requiresAdminOrSuperAdmin && !context.hasAdminRole && !context.hasSuperAdminRole) {
    return false;
  }

  if (item.requiresSuperAdmin && !context.hasSuperAdminRole) {
    return false;
  }

  if (item.requiresBillingOrSuperAdmin && !context.hasBillingRole && !context.hasSuperAdminRole) {
    return false;
  }

  if (item.requiresNotBilling && context.hasBillingRole) {
    return false;
  }

  if (item.requiresLicensesAccess && !context.hasLicensesAccess) {
    return false;
  }

  if (item.featureFlag && !context.featureFlags.includes(item.featureFlag)) {
    return false;
  }

  if (item.hiddenWhenFeatureFlag && context.featureFlags.includes(item.hiddenWhenFeatureFlag)) {
    return false;
  }

  return true;
}

export function getVisibleOldMainMenuItems(
  context: HeaderOldMainMenuContext
): HeaderOldMainMenuItem[] {
  return OLD_MAIN_MENU_ITEMS.filter((item: HeaderOldMainMenuItem) =>
    isOldMainMenuItemVisible(item, context)
  ).map((item: HeaderOldMainMenuItem) => ({
    ...item,
    disabled: item.kind === 'device-menu' && !context.hasDevices,
  }));
}
